<div class="avatar" (click)="openNotificationModal()">
  <p-avatar size="xlarge" shape="circle" [label]="userService.getAvatarInitial(userService.currentUser)"
            [image]="userService.getAvatarImage(userService.currentUser)"
            [style]="{'background-color': 'var(--ui-avatar-background)', width: '2rem', height: '2rem', 'font-size': '1rem'}"></p-avatar>
  <div class="badge">
    <p-badge *ngIf="this.notificationService.notificationNumber > 0 && !notificationPopupOpen" [value]="this.notificationService.notificationNumber.toString()" severity="danger" [style]="{'font-size': '10px',padding: '0px 10px', 'min-width': '22px'}"></p-badge>
  </div>

</div>
<notification-badge [@openClose]="notificationPopupOpen ? 'open' : 'closed'" (onClose)="closePopup()" (clickOutside)="closePopup()" [clickOutsideEnabled]="notificationPopupOpen"></notification-badge>
